import React from "react";
import { AgencyDocumentCategory, PassportDocumentType } from "../../../../messages";
import { AgencyId } from "../../../../messages/ObjectIds";
import { AgencyDocumentType } from "../../../../messages/UploadedDocuments";
import { OrientationLanguages } from "../../../../messages/Video";
import { withDefault } from "../../../../utils/withDefault";
import {
  CategorizedList,
  CategorizedListContent,
  CategorizedListItem,
  CategorziedListHeader,
} from "../../../Generic/CategorizedList/CategorizedList";
interface Props {
  agencyCategory: AgencyDocumentCategory;
  language: OrientationLanguages;
  isContentOpen: boolean;
  onClickAgencyDocumentType: (
    agencyId: AgencyId,
    documentType: PassportDocumentType | AgencyDocumentType
  ) => void;
  onClickAgencyCatergoryHeader: (
    agencyId: AgencyId,
    contentRef: React.RefObject<HTMLDivElement>
  ) => void;
}

const AgencyCategory = (props: Props) => {
  const contentRef = React.useRef<HTMLDivElement>(null);
  const {
    agencyCategory,
    language,
    isContentOpen,
    onClickAgencyDocumentType,
    onClickAgencyCatergoryHeader,
  } = props;

  const handleClickAgencyCatergoryHeader = React.useCallback(() => {
    onClickAgencyCatergoryHeader(agencyCategory.agencyId, contentRef);
  }, [agencyCategory.agencyId, onClickAgencyCatergoryHeader]);

  return (
    <CategorizedList>
      <CategorziedListHeader
        primaryText={agencyCategory.agencyName}
        onClick={handleClickAgencyCatergoryHeader}
      />
      <CategorizedListContent ref={contentRef} isOpen={isContentOpen}>
        {agencyCategory.documents.map((document) => (
          <CategorizedListItem
            key={document.id.toString()}
            onClick={() => onClickAgencyDocumentType(agencyCategory.agencyId, document)}
            primaryText={withDefault(
              document.documentName[language],
              document.documentName.English
            )}
          />
        ))}
      </CategorizedListContent>
    </CategorizedList>
  );
};

export default React.memo(AgencyCategory);
